import RegisterSectionRenderer from "./RegisterSectionRenderer";

function RegisterPersonal(props: any) {
    return <RegisterSectionRenderer {...props} renderBlocksAsAccordion accordionDefaultOpenAll scrollClass="register-personal-scroll"/>;
}

export default RegisterPersonal;
